import React from 'react'
import { Form, Div, P, A, H1 } from '@drifthq/tide-core'
import './styles.css'
import verificationEmailSentSrc from './email-sent.svg'

const FindMyTeamEmailSent = ({
  email,
  onContinueClick,
  onEntryValidate,
  onTryAgain
}) => {
  onEntryValidate()
  return (
    <Form className="touchless-start-fields" onSubmit={onContinueClick}>
      <Div className="email-sent-success">
        <img src={verificationEmailSentSrc} width={180} alt="email verification sent" className="email-sent"/>
        <H1> Check your email! </H1>
        <P className="success-copy"> We’ve sent a verification email to <strong>{email}</strong>. Follow the instructions in the email to get started! </P>
        <P className="try-again-copy"> Didn’t receive an email? <A onClick={onTryAgain}> Try a different email address </A></P>
      </Div>
    </Form>
  )
}

export default FindMyTeamEmailSent



// WEBPACK FOOTER //
// ./src/layouts/FindMyTeam/FindMyTeamEmailSent/component.js